import { render, staticRenderFns } from "./Honour.vue?vue&type=template&id=152b59e0&scoped=true"
import script from "./Honour.vue?vue&type=script&lang=js"
export * from "./Honour.vue?vue&type=script&lang=js"
import style0 from "./Honour.vue?vue&type=style&index=0&id=152b59e0&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "152b59e0",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/drone/src/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('152b59e0')) {
      api.createRecord('152b59e0', component.options)
    } else {
      api.reload('152b59e0', component.options)
    }
    module.hot.accept("./Honour.vue?vue&type=template&id=152b59e0&scoped=true", function () {
      api.rerender('152b59e0', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/aboutUS/components/Honour.vue"
export default component.exports